export function defaultOptionsValues(mapping) {
  return {
    isPyramid: true,
    barsOrientation: 'horizontal',
    sortBy: 'original',
    sortBarsBy: 'original',
    groupSeriesInStack: true,
  };
}
